import React from "react"
import { slideInDownAnimate } from "utils/animation"

const HeroHeader = ({ title, textColor }) => {
  return (
    <h1
      className={`headTitle text-uppercase display-2 mb-6 text-${textColor}`}
      style={slideInDownAnimate("900ms")}
    >
      {title}
    </h1>
  )
}

export default HeroHeader
